import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { FISCAL_YEAR_QUERY_KEYS } from './keys';

import * as fiscalYearService from 'services/fiscalYear';

interface FiscalYear {
  id: string;
  name: string;
  startDate?: string;
  endDate?: string;
}

export function useFetchFiscalYearByCountry(country: string, shouldFetch = true): UseQueryResult<FiscalYear[]> {
  return useQuery<FiscalYear[], Error>({
    queryKey: [FISCAL_YEAR_QUERY_KEYS.BY_COUNTRY, country],
    queryFn: () => fiscalYearService.fetch({ country }) as Promise<FiscalYear[]>,
    enabled: Boolean(country) && shouldFetch,
  });
}
